<template>
  <nav class="navbar navbar-expand-lg sticky-top navbar-light bg-light">
    <div class="container">
      <a class="navbar-brand" href="/">
        <img src="@assets/images/SensorUp_RGB_web_logo.png" alt="SensorUp">
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavAltMarkup"
        aria-controls="navbarNavAltMarkup"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end" id="navbarNavAltMarkup">
        <div class="navbar-nav">
          <a href="https://www.sensorup.com" target="_blank" class="nav-item nav-link">
            <span>Mainsite</span>
          </a>
        </div>
        <div class="navbar-nav">
          <a href="https://smartcanada.sensorup.com" target="_blank" class="nav-item nav-link">
            <span>Air Map</span>
          </a>
        </div>
        <div
          class="navbar-nav"
          v-if="navRoutes"
          v-for="navRoute in navRoutes"
          :key="navRoute.title"
        >
          <router-link class="nav-item nav-link" :to="navRoute.path">
            <span>{{navRoute.name}}</span>
          </router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      currentView: '',
      navRoutes: [
        {
          path: '/instructions/assembly',
          name: 'Instructions',
        },
        {
          path: '/register',
          name: 'Register',
        },
        {
          path: '/troubleshooting',
          name: 'Troubleshooting',
        },
        {
          path: '/faq',
          name: 'FAQ',
        },
        {
          path: '/support',
          name: 'Support',
        },
      ],
    }
  },
  created() {},
  computed: {},
  methods: {},
}
</script>

<style>
.navbar-brand img {
  height: 30px;
}
</style>
